import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FaCheckCircle, FaTruck, FaClock } from "react-icons/fa";
import { supabase } from "../supabaseClient";

const Success = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(null);
  const [errorMsg, setError] = useState(null);

  const sessionId = params.get("session_id");

  // ✅ Solución más fiable para Stripe → si vuelve atrás, redirigimos
  useEffect(() => {
    const handlePopState = () => {
      console.log("↩️ Usuario intentó volver atrás desde Stripe, redirigiendo...");
      window.location.href = "/"; // o "/tienda" si prefieres
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    const fetchOrder = async () => {
      console.log("🧾 Session ID recibido en Success:", sessionId);

      if (!sessionId) {
        setError("No se recibió el ID de sesión de Stripe 😢");
        setLoading(false);
        return;
      }

      try {
        console.log("🔍 Buscando pedido en Supabase con session_id:", sessionId);

        const { data: orders, error } = await supabase
          .from("orders")
          .select("*")
          .eq("stripe_session_id", sessionId);

        console.log("📦 Resultado de Supabase:", orders);

        if (error) {
          console.error("❌ Error obteniendo pedido:", error.message);
          setError("No se pudo cargar el pedido 😢");
          return;
        }

        if (!orders || orders.length === 0) {
          console.warn("⚠️ No se encontró ningún pedido con ese session_id");
          setError("No se encontró el pedido. 😕");
          return;
        }

        setOrder(orders[0]);
      } catch (err) {
        console.error("⚠️ Error inesperado:", err);
        setError("Ocurrió un error al cargar el pedido 😢");
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [sessionId]);

  if (loading) {
    return (
      <p style={{ textAlign: "center", marginTop: "60px" }}>
        Cargando detalles del pedido...
      </p>
    );
  }

  if (errorMsg) {
    return (
      <p style={{ textAlign: "center", marginTop: "60px", color: "red" }}>
        {errorMsg}
      </p>
    );
  }

  if (!order) {
    return (
      <p style={{ textAlign: "center", marginTop: "60px", color: "red" }}>
        No se encontró el pedido. 😕
      </p>
    );
  }

  return (
    <div
      style={{
        textAlign: "center",
        padding: "60px 20px",
        fontFamily: "Arial, sans-serif",
        color: "#333",
      }}
    >
      <FaCheckCircle size={80} color="#4B6CB7" />
      <h1 style={{ marginTop: "20px", color: "#333" }}>
        ¡Pago completado exitosamente!
      </h1>

      <p style={{ fontSize: "18px", marginTop: "10px", color: "#555" }}>
        Tu pedido #{order.id?.slice(0, 8)} ha sido recibido y está siendo procesado.
      </p>
      <p style={{ fontSize: "18px", color: "#4B6CB7" }}>
        💶 Total: {(order.total_amount / 100).toFixed(2)} €
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "40px",
          marginTop: "50px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <FaTruck size={40} color="#4B6CB7" />
          <p style={{ marginTop: "10px" }}>En camino pronto</p>
        </div>
        <div style={{ textAlign: "center" }}>
          <FaClock size={40} color="#4B6CB7" />
          <p style={{ marginTop: "10px" }}>Entrega estimada: 2-3 días</p>
        </div>
      </div>
    </div>
  );
};

export default Success;
